import { Offcanvas, Form, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';

const FilterOffcanvas = ({ 
    show, 
    onHide,
    stageFilter,
    setStageFilter,
    stageOptions
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Workflow</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Workflow</Form.Label>
                                <Select
                                    value={stageFilter}
                                    onChange={setStageFilter}
                                    options={stageOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={() => {
                        setStageFilter(null);
                    }}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterOffcanvas;
